export type AppConfigResponse = {
  apiHost: string;
  appId: string;
  recaptchaSitekey: string;
  urlPrefix: string;
};

export type AppConfig = AppConfigResponse & {
  environment: string;
  storageDrive: 's3' | 'azure';
  uploadFolder: string;
};

export type AppConfigInitializer = { configUrl?: string; initial: AppConfig };
